module.exports = __webpack_public_path__ + "img/speaker-icon.8dd302bd.svg";